import React , { useState} from 'react'
import { useNavigate } from 'react-router-dom'

import '../styles/trackform.css'

const TrackForm = () => {
  const initialState = {  bol: ''}
  const [formData, setFormData] = useState(initialState);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ [e.target.name]: e.target.value });
  }

  const handleSubmit = (e) => {
    navigate(`/track-shipment/${formData.bol}`)
  }
  return (
    <>
      <div className="trackform">
        <form onSubmit={handleSubmit} className='filler'>
          <input type="text" name="bol" id="bol" onChange={handleChange} placeholder='Enter Tracking Number (BOL)' required />
          <button type="submit">Track & Trace</button>
        </form>
      </div>
    </>
  )
}

export default TrackForm